import React from 'react';
import { Flex, IconButton, Button, useMediaQuery } from '@chakra-ui/react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const PocPagination = ({
  colorMode,
  objectCount,
  hasPrevious,
  hasNext,
  goPrevious,
  goNext,
  pageCount,
  goToPage
}) => {
  const totalPages = Math.ceil(objectCount / 10);
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  
  const getPageNumbers = () => {
    if (totalPages <= 1) return [];
    
    const maxVisible = isMobile ? 5 : 10;
    const currentPage = parseInt(pageCount, 10) || 1;
    let startPage, endPage;

    if (totalPages <= maxVisible) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const maxLeft = Math.floor(maxVisible / 2);
      const maxRight = Math.ceil(maxVisible / 2) - 1;

      if (currentPage <= maxLeft) {
        startPage = 1;
        endPage = maxVisible;
      } else if (currentPage + maxRight >= totalPages) {
        startPage = totalPages - maxVisible + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxLeft;
        endPage = currentPage + maxRight;
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  const pageNumbers = getPageNumbers();
  const currentPage = parseInt(pageCount, 10) || 1;

  return (
    <Flex
      gap={4}
      mt={4}
      justify="end"
      w="full"
      alignItems="center"
    >
      <Flex gap={1} alignItems="center">
        <IconButton
          variant="pageButton"
          icon={<IoIosArrowBack />}
          onClick={goPrevious}
          isDisabled={!hasPrevious}
          aria-label="previous"
        />

        {pageNumbers.map(page => (
          <Button
            key={page}
            variant="pageButton"
            minW="8"
            h="8"
            p="0"
            fontSize="sm"
            bg={page === currentPage 
                ? (colorMode === 'light' ? 'gray.300' : 'gray.600') 
                : (colorMode === 'light' ? 'white' : 'gray.700')}
            borderWidth="1px"
            borderColor={colorMode === 'light' ? 'gray.200' : 'gray.600'}
            color={colorMode === 'light' ? 'gray.800' : 'white'}
            _hover={
              page === currentPage 
                ? undefined 
                : { 
                    bg: colorMode === 'light' ? 'gray.50' : 'gray.600',
                    borderColor: colorMode === 'light' ? 'gray.300' : 'gray.500'
                  }
            }
            onClick={() => goToPage(page)}
            isDisabled={page === currentPage}
            aria-label={`Page ${page}`}
          >
            {page}
          </Button>
        ))}

        <IconButton
          variant="pageButton"
          icon={<IoIosArrowForward />}
          onClick={goNext}
          isDisabled={!hasNext}
          aria-label="next"
        />
      </Flex>
    </Flex>
  );
};

export default PocPagination;